<template>
    <div id="fccTipoPublicacao" class="fccSpi">
      <v-select
        :options="listarPublicacaoTipo"
        v-model="tipoPublicacao"
        :placeholder="name"
        class="selectSPI"
        label="dstipo"
        @input="setSelected">
        <template #search="{attributes, events}">
            <input
             class="vs__search"
            :required="!tipoPublicacao"
            v-bind="attributes"
             v-on="events"
            />
        </template>
      </v-select>
    </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import './assets/fccSpi.scss'

export default {
  name: 'fccTipoPublicacao',
  data: () => ({
    listarPublicacaoTipo: [],
    tipoPublicacao: '',
    name: 'Selecione o Tipo de Publicação'
  }),
  methods: {
    setSelected: function () {
      this.$emit('changesTipoPublicacao', this.tipoPublicacao)
    },
    listandoTipoPublicacao: function () {
      axios.get(store.state.baseUrlPublicacao + 'PublicacaoTipo/ListarPublicacaoTipo', this.dadosLoginSession.fccTokenHeaders)
        .then(response => {
          this.listarPublicacaoTipo = response.data
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted: function () {
    this.listandoTipoPublicacao()
  }
}
</script>
